import { baseApi } from "../../components/src/app-main/store/baseApi";
import publicConfig from "../../public-config";

type AmenityOption = {
  id: string;
  name: string;
  default: boolean;
};

type ListingAmenitiesResponse = {
  amenities: {
    events: AmenityOption[];
    offsite: AmenityOption[];
    production: AmenityOption[];
  };
};

type GetListingAmenitiesArgs = {
  locale: string;
};

const envApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Returns amenity options a host can select from when activating a listing use
     * type, grouped by use type.
     *
     * EnvAPI's `/env/*` routes require a shared "handshake" secret in
     * `Authorization`, not a user access token (see `EnvAPI/lib/helpers.js`'s
     * `handshake` middleware) — same auth scheme the legacy `getWebEnv`
     * (`api-env.js`) already uses for the sibling `/env/web/:locale` route.
     * `useAuth: false` stops `baseApi` from overwriting this with the
     * logged-in user's token.
     */
    getListingAmenities: builder.query<
      ListingAmenitiesResponse,
      GetListingAmenitiesArgs
    >({
      query: ({ locale }) => ({
        url: `/v1/env/listings/${locale}`,
        headers: {
          Authorization: `Bearer ${btoa(publicConfig.env_handshake)}`,
        },
      }),
      extraOptions: { useAuth: false },
    }),
  }),
  overrideExisting: false,
});

const { useGetListingAmenitiesQuery } = envApi;

export {
  useGetListingAmenitiesQuery,
  type AmenityOption,
  type ListingAmenitiesResponse,
  type GetListingAmenitiesArgs,
};
